export default __webpack_public_path__ + "static/media/CNP-Refund.88ce8f65.yaml";